import MapboxDraw, { DrawCustomModeThis } from "@mapbox/mapbox-gl-draw";
import { Feature } from "geojson";

const {
  constants: Constants,
  lib: {
    CommonSelectors: { isOfMetaType },
  },
} = MapboxDraw;

const isVertex = isOfMetaType(Constants.meta.VERTEX);
const isMidpoint = isOfMetaType(Constants.meta.MIDPOINT);

/**
 * If we are drawing with the optional setting `editingLayerIds` then we need to
 * ensure that we only select features from those layers. This function overrides
 * the event's featureTarget if the feature at the mouse event is not from an
 * allowed layer.
 *
 * Note that this relies on features having a `layerId` property which is set when
 * the feature is created.
 */
export function getFeatureTarget(
  this: DrawCustomModeThis,
  originalEvent: MapboxDraw.MapMouseEvent,
  opts: MapboxDraw.MapboxDrawOptions
): Feature | undefined {
  if (opts.editingLayerIds && opts.editingLayerIds.length > 0) {
    const features = this.featuresAt(originalEvent, null).filter((feature) => {
      let featureTarget: Feature = feature;
      // @ts-expect-error featureTarget is defined as MapboxDraw.DrawFeature although it is a GeoJSON Feature.
      const event = { ...originalEvent, featureTarget } as MapboxDraw.MapMouseEvent;
      // If the feature clicked is a vertex or midpoint then we need to get the parent feature
      // to check its layerId.
      if (isVertex(event) || isMidpoint(event)) featureTarget = this.getFeature(feature.properties?.parent).toGeoJSON() as Feature;

      // Only return features that are from the allowed editing layers.
      const layerId = featureTarget?.properties?.layerId || featureTarget?.properties?.user_layerId;
      return opts.editingLayerIds?.includes(layerId);
    });

    // If we found any features from the allowed layers then return the first one.
    return features?.[0];
  }

  // If no editingLayerIds are set then just return the original featureTarget.
  // @ts-expect-error featureTarget is defined as MapboxDraw.DrawFeature although it is a GeoJSON Feature.
  return originalEvent.featureTarget;
}
